import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Organization} from "../../../interfaces/organization";

@Component({
  selector: 'app-modal-organization',
  templateUrl: './modal-organization.component.html',
  styleUrls: ['./modal-organization.component.scss']
})
export class ModalOrganizationComponent {
  @Input() organization: Organization;
  @Output() saveOrganizationData = new EventEmitter<Organization>();

  public isOrganizationModalShow = false;
  public isDarkBackground = false;
  public nameError = false;
  public nameErrorMessage = '';
  public edrpouError = false;
  public edrpouErrorMessage = '';
  /** Текст ошибки, с которой бэк отказал в сохранении (#358) — показывается под полями */
  public serverError = '';
  /** Запрос на сохранение в полёте: модалку закроет родитель после ответа сервера */
  public isSaving = false;

  modalShow() {
    this.serverError = '';
    this.isSaving = false;
    this.isOrganizationModalShow = true;
    this.isDarkBackground = true;
  }

  // #358: ТОВ — код ЄДРПОУ (8 цифр), ФОП — РНОКПП (10 цифр); то же правило проверяет бэк
  get edrpouLength(): number {
    return this.organization.type === 'tov' ? 8 : 10;
  }

  // Смена формы власності: лишние цифры обрезаем до нужной длины и перепроверяем уже введённый код
  onTypeChange() {
    if (!this.organization.edrpou) {
      return;
    }

    this.validationOrganizationEdrpou();
  }

  validationOrganizationName() {
    if (!this.organization.name || this.organization.name.trim() === '') {
      this.nameError = true;
      this.nameErrorMessage = 'Назва компанії обовʼязкова';
    } else {
      this.nameError = false;
      this.nameErrorMessage = '';
    }
  }

  validationOrganizationEdrpou() {
    this.organization.edrpou = String(this.organization.edrpou || '').replace(/\D/g, '').slice(0, this.edrpouLength);

    if (!this.organization.edrpou || this.organization.edrpou.length !== this.edrpouLength) {
      this.edrpouError = true;
      this.edrpouErrorMessage = this.organization.type === 'tov'
        ? 'ЄДРПОУ має містити 8 цифр'
        : 'РНОКПП має містити 10 цифр';
    } else {
      this.edrpouError = false;
      this.edrpouErrorMessage = '';
    }
  }

  saveOrganization() {
    if (this.isSaving) {
      return;
    }

    this.serverError = '';
    this.validationOrganizationName();
    this.validationOrganizationEdrpou();

    if (this.nameError || this.edrpouError) {
      return;
    }

    this.organization.name = this.organization.name.trim();

    // Модалку не закрываем: родитель закроет её после успешного ответа (closeModal),
    // а при отказе бэка покажет причину здесь же (saveFailed) — данные пользователя не теряются
    this.isSaving = true;
    this.saveOrganizationData.emit(this.organization);
  }

  /** Бэк не сохранил организацию: показать причину в модалке и разрешить повторную попытку */
  saveFailed(message: string) {
    this.isSaving = false;
    this.serverError = message;
  }

  closeModal() {
    this.isSaving = false;
    this.isOrganizationModalShow = false;
    this.isDarkBackground = false;
  }
}
